/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";

export class LottieAssetModel<T extends LottieAssetModel.IJson> extends JsonModel<T> {}

export namespace LottieAssetModel {
  export interface IJson {
    /**
     * Unique identifier used by layers when referencing this asset
     * @default ""
     */
    id: string;

    /**
     * Human readable name
     */
    nm?: string;
  }
}
/* v8 ignore stop */
